import { forwardRef } from "react";
import { Checkbox, FormControlLabel, List, ListItem } from "@mui/material";

export interface CheckboxListItem {
  id: string;
  label: string;
  checked: boolean;
}

export interface CheckboxListProps {
  items: CheckboxListItem[];
  onToggle: (id: string) => void;
}

/** A dense list of labeled checkboxes. */
export const CheckboxList = forwardRef<HTMLUListElement, CheckboxListProps>(
  ({ items, onToggle }, ref) => (
    <List ref={ref} dense disablePadding data-testid="ds-checkbox-list">
      {items.map((item) => (
        <ListItem
          key={item.id}
          disableGutters
          sx={{ py: 0.25, px: 1 }}
          data-testid={`ds-checkbox-list-item-${item.id}`}
        >
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={item.checked}
                onChange={() => onToggle(item.id)}
              />
            }
            label={item.label}
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.8125rem" } }}
          />
        </ListItem>
      ))}
    </List>
  ),
);

CheckboxList.displayName = "CheckboxList";
